var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 351.74 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-7{fill:none;}.cls-2{fill:#1e1c55;}.cls-3{fill:#ff1c3b;}.cls-4{fill:#999;}.cls-5{fill:#fff;}.cls-6{fill:#ffbd3d;}.cls-7{stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Badge6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Badge"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Badge6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.69,163.29c-.07-2.38-.1-4.66-.1-6.78,0-12.42.43-24.48,1.26-35.8H70.42c.84,11.4,1.29,23.5,1.29,35.8,0,2,0,4.18-.09,6.38a128.53,128.53,0,0,0,1.85,25.64c29-2,64.88-3.09,102.54-3.09s73.77,1.14,102.89,3.11A127.82,127.82,0,0,0,280.69,163.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.4,162.64c.06-2.12.08-4.18.08-6.13,0-12.33-.45-24.44-1.31-35.8H18.24l-9,9v55.94L20,194.56l.92-.18c10.31-2,25.24-3.78,43.34-5.19A136.62,136.62,0,0,1,62.4,162.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.91,163a133.81,133.81,0,0,1-1.84,26.19c17.79,1.39,32.5,3.12,42.74,5.11l.91.18,10.8-8.9V129.73l-9-9H291.12c-.85,11.37-1.31,23.5-1.31,35.8C289.81,158.54,289.84,160.73,289.91,163Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287,81.47a86.9,86.9,0,0,1-36.14-43.62H100.91A87,87,0,0,1,65.27,81.16a293.73,293.73,0,0,1,4.37,30.33h213A290,290,0,0,1,287,81.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.39,197.63A124.78,124.78,0,0,0,175,290.47l.92.17,1.47-.27c49.95-9,88-45.82,99.65-92.71-28.61-1.91-63.9-3-101-3S103.93,195.74,75.39,197.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.39,197.63A124.78,124.78,0,0,0,175,290.47l.92.17,1.47-.27c49.95-9,88-45.82,99.65-92.71-28.61-1.91-63.9-3-101-3S103.93,195.74,75.39,197.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.83,37.85H100.91A87,87,0,0,1,65.27,81.16a293.73,293.73,0,0,1,4.37,30.33h213a290,290,0,0,1,4.34-30A86.9,86.9,0,0,1,250.83,37.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337.32,111.49h-45.4a275.28,275.28,0,0,1,4.48-30.07l.11-.48V76.32L294.16,75a77.78,77.78,0,0,1-35.7-43.22l-1.06-3.15H94.33l-1,3.15a77.84,77.84,0,0,1-35.5,43.1l-3,1.69.75,3.33a264.93,264.93,0,0,1,4.81,31.59H14.42L0,125.91V190l17.54,14.43,5.18-1c10.26-2,25.23-3.75,43.44-5.14A134.84,134.84,0,0,0,173.32,299.55l2.55.45.79-.14,2.32-.41A134.92,134.92,0,0,0,286.21,198.31c17.91,1.38,32.66,3.1,42.84,5.07l5.18,1L351.74,190V125.91Zm5.2,74.12-10.8,8.9-.91-.18c-10.24-2-24.95-3.72-42.74-5.11q-4.45-.34-9.17-.67c-29.12-2-65.11-3.11-102.89-3.11s-73.5,1.12-102.54,3.09q-4.71.32-9.18.66c-18.1,1.41-33,3.17-43.34,5.19l-.92.18L9.22,185.67V129.73l9-9H333.5l9,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M331.22,123.86H21.66l-7.76,7.65v52.73l9.26,7.51c27.45-5.31,87.67-8.74,153.43-8.74,65.46,0,125.58,3.41,153.16,8.69l9.24-7.51V131.51Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 111.61,
    y1: 138.35,
    x2: 97.17,
    y2: 138.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104.62,79.24H98.9V75.87h15.57v3.37h-5.72v14.5h-4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M130.78,90.42v3.32H116.94V75.87h13.51v3.32h-9.4v3.88h8.3v3.22h-8.3v4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M133.15,84.81c0-5.39,4.14-9.25,9.7-9.25a9.22,9.22,0,0,1,7.35,3.17l-2.65,2.45a5.75,5.75,0,0,0-4.49-2.09,5.72,5.72,0,1,0,0,11.43,5.7,5.7,0,0,0,4.49-2.11l2.65,2.45a9.19,9.19,0,0,1-7.37,3.19C137.29,94.05,133.15,90.19,133.15,84.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M169.63,75.87V93.74h-4.14V86.41h-8.12v7.33h-4.13V75.87h4.13v7h8.12v-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M174.12,75.87h4.13V93.74h-4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M199,93.74,199,83l-5.26,8.83h-1.86l-5.24-8.6V93.74h-3.88V75.87h3.42L192.85,87l6.59-11.11h3.39l0,17.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M222.87,82.35c0,4-3,6.46-7.76,6.46h-3.6v4.93h-4.14V75.87h7.74C219.88,75.87,222.87,78.35,222.87,82.35Zm-4.19,0c0-2-1.27-3.11-3.8-3.11h-3.37v6.2h3.37C217.41,85.44,218.68,84.3,218.68,82.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M226.06,75.87h4.13v14.5h9v3.37H226.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M248.47,87.41v6.33h-4.14V87.36l-6.91-11.49h4.39l4.77,7.94,4.77-7.94h4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M166,206.05s-.57,13.52,2.27,18.78a21.3,21.3,0,0,0,7,7.18.49.49,0,0,0-.34.46v.69a.49.49,0,0,0,.49.49h.43v6.49l-1.21,2.07h-1.36l-2.47,2.51v4.08h-1.23v1h15v-1h-1.22v-4.12l-2.57-2.47h-1.26l-1.2-2.07h0v-6.49h.25a.49.49,0,0,0,.49-.49v-.69a.48.48,0,0,0-.24-.41,21.46,21.46,0,0,0,7-7.23c2.25-4.17,2.36-13.56,2.3-17.25h0v-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M169.72,249.57h14.62V249h-1a.19.19,0,0,1-.19-.19v-4l-2.45-2.35h-1.19a.19.19,0,0,1-.17-.1l-1.19-2.05a.17.17,0,0,1,0-.12v-6.49a.19.19,0,0,1,.19-.2h.25a.29.29,0,0,0,.29-.29v-.69a.3.3,0,0,0-.14-.25.17.17,0,0,1-.09-.16.19.19,0,0,1,.08-.16,21.48,21.48,0,0,0,7-7.16c2.22-4.12,2.33-13.37,2.28-17.15v-1.37a70.51,70.51,0,0,0-21.75,0c0,1.53-.36,13.67,2.25,18.52a20.94,20.94,0,0,0,6.9,7.11.18.18,0,0,1,.09.19.22.22,0,0,1-.14.16.28.28,0,0,0-.21.27v.69a.3.3,0,0,0,.3.29h.43a.2.2,0,0,1,.19.2v6.49a.17.17,0,0,1,0,.1l-1.2,2.07a.21.21,0,0,1-.17.1H173.3l-2.36,2.39v4a.2.2,0,0,1-.19.19h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M194.29,207.19a4.13,4.13,0,0,0-5.53,2.25,3.82,3.82,0,0,0,0,3,3.34,3.34,0,0,0,2,1.77.52.52,0,0,0,.67-.33.53.53,0,0,0-.33-.67,2.34,2.34,0,0,1-1.29-1,3.17,3.17,0,0,1-.11-1.12,3,3,0,0,1,.07-.51,2.46,2.46,0,0,1,2.38-1.68,2.7,2.7,0,0,1,2.44,2.3,7.69,7.69,0,0,1-.12,4.17,15,15,0,0,1-3.94,4.65l-.83.68-.67.5a6.47,6.47,0,0,0-2.45,2.64,3.34,3.34,0,0,0,.17,2.84,2.72,2.72,0,0,0,2.36,1.46A2.65,2.65,0,0,0,190,228c1.18-.42,2.21-1.54,1.79-2.8a.53.53,0,1,0-1,.33c.24.72-.66,1.3-1.13,1.47a1.6,1.6,0,0,1-1.94-.82,2.26,2.26,0,0,1-.13-1.93,5.64,5.64,0,0,1,2.1-2.19l.7-.52c.29-.23.58-.46.86-.7,2.89-2.44,4.48-4.76,5-7.32C196.52,212.33,197.13,208.28,194.29,207.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M192.12,208.74h.06c1.26,0,2.21.91,2.63,2.44a7.92,7.92,0,0,1-.13,4.28,0,0,0,0,1,0,0,15.19,15.19,0,0,1-4,4.71l-.84.68c-.22.17-.44.34-.67.5a6.37,6.37,0,0,0-2.39,2.56,3.1,3.1,0,0,0,.17,2.67,2.47,2.47,0,0,0,2.18,1.36h0a2.23,2.23,0,0,0,.81-.14,2.19,2.19,0,0,0,1.67-2.55.34.34,0,0,0-.17-.2.36.36,0,0,0-.25,0,.34.34,0,0,0-.2.17.33.33,0,0,0,0,.26c.27.83-.63,1.49-1.26,1.71a1.78,1.78,0,0,1-2.17-.91,2.44,2.44,0,0,1-.14-2.09,5.67,5.67,0,0,1,2.16-2.27l.7-.52c.31-.25.59-.47.86-.7,2.85-2.4,4.42-4.7,5-7.21.24-1.18.84-5.1-1.86-6.14h0a4,4,0,0,0-5.28,2.14,3.63,3.63,0,0,0,0,2.89,3.15,3.15,0,0,0,1.91,1.67.34.34,0,0,0,.26,0,.35.35,0,0,0,.17-.19.34.34,0,0,0-.22-.43,2.5,2.5,0,0,1-1.39-1.08s0,0,0,0a3.59,3.59,0,0,1-.12-1.18,2.51,2.51,0,0,1,2.59-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M167.42,223.88a6.47,6.47,0,0,0-2.45-2.64l-.67-.5-.83-.68a15,15,0,0,1-3.94-4.65,7.69,7.69,0,0,1-.12-4.17,2.7,2.7,0,0,1,2.45-2.3,2.46,2.46,0,0,1,2.37,1.68,2.24,2.24,0,0,1,.07.51,3.17,3.17,0,0,1-.11,1.12,2.35,2.35,0,0,1-1.28,1,.53.53,0,1,0,.34,1,3.32,3.32,0,0,0,2-1.77,3.82,3.82,0,0,0,0-3,4.13,4.13,0,0,0-5.53-2.25c-2.84,1.09-2.23,5.14-2,6.36.54,2.56,2.13,4.88,5,7.32.28.24.57.47.86.7l.7.52a5.57,5.57,0,0,1,2.1,2.19,2.26,2.26,0,0,1-.13,1.93,1.6,1.6,0,0,1-1.94.82c-.47-.17-1.37-.75-1.13-1.47a.53.53,0,1,0-1-.33c-.42,1.26.61,2.38,1.79,2.8a2.65,2.65,0,0,0,.87.15,2.72,2.72,0,0,0,2.36-1.46A3.34,3.34,0,0,0,167.42,223.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M162.73,225.06a.4.4,0,0,0-.15,0,.34.34,0,0,0-.17.2,2.19,2.19,0,0,0,1.67,2.55,2.3,2.3,0,0,0,.81.14h0a2.49,2.49,0,0,0,2.19-1.36,3.13,3.13,0,0,0,.16-2.67h0a6.42,6.42,0,0,0-2.38-2.56c-.24-.17-.47-.33-.68-.5s-.58-.47-.84-.68a15.19,15.19,0,0,1-4-4.71,0,0,0,0,1,0,0,7.92,7.92,0,0,1-.13-4.28c.42-1.53,1.37-2.42,2.63-2.44a2.45,2.45,0,0,1,2.65,2.37,3.57,3.57,0,0,1-.12,1.18l0,0a2.5,2.5,0,0,1-1.39,1.08.33.33,0,0,0-.21.43.32.32,0,0,0,.17.19.31.31,0,0,0,.25,0,3.15,3.15,0,0,0,1.91-1.67,3.63,3.63,0,0,0,0-2.89,4,4,0,0,0-5.28-2.14c-2.7,1-2.1,5-1.86,6.14.53,2.51,2.1,4.81,5,7.21l.85.7.7.52a5.67,5.67,0,0,1,2.16,2.27,2.44,2.44,0,0,1-.14,2.09,1.78,1.78,0,0,1-2.17.91c-.63-.22-1.53-.88-1.26-1.71a.33.33,0,0,0,0-.26.35.35,0,0,0-.19-.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 178.56,
    y: 215.11,
    width: 2.58,
    height: 9.04
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "171.43 213.01 171.43 215.11 174.99 215.11 174.99 215.38 174.99 224.15 177.57 224.15 177.57 215.38 177.57 215.11 178.56 215.11 178.56 213.01 171.43 213.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 178.56,
    y: 213.01,
    width: 2.58,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 178.56,
    y: 210.1,
    width: 2.58,
    height: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M210.48,263.16l1.16-4.29-3.46-2.79,4.44-.22,1.58-4.15,1.59,4.15,4.44.22-3.47,2.79,1.17,4.29-3.73-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M236.72,240.56l.74-2.73-2.21-1.78,2.83-.14,1-2.65,1,2.65,2.83.14-2.21,1.78.74,2.73L239.09,239Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M254.62,215.17l.51-1.87-1.51-1.21,1.94-.1.69-1.81.68,1.81,1.94.1-1.51,1.21.51,1.87-1.62-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M175.26,274.77l-6.2-.2,4.77-4-1.73-6,5.25,3.3,5.14-3.48-1.52,6,4.9,3.81-6.19.41-2.11,5.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M140.27,260.73l-3.72,2.43,1.16-4.29-3.46-2.79,4.44-.22,1.58-4.15,1.59,4.15,4.44.22-3.47,2.79,1.17,4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115.39,239,113,240.56l.74-2.73-2.21-1.78,2.83-.14,1-2.65,1,2.65,2.83.14L117,237.83l.74,2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M98.23,214.11l-1.62,1.06.51-1.87-1.51-1.21,1.94-.1.68-1.81.69,1.81,1.94.1-1.51,1.21.51,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.24,136H71.31v-2.9H84.72V136H79.8v12.49H76.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85.45,140.78c0-4.58,3.56-8,8.42-8s8.42,3.36,8.42,8-3.58,7.95-8.42,7.95S85.45,145.35,85.45,140.78Zm13.23,0a4.82,4.82,0,1,0-4.81,4.92A4.69,4.69,0,0,0,98.68,140.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M118.32,138.66c0,3.43-2.58,5.57-6.69,5.57h-3.1v4.24H105V133.08h6.66C115.74,133.08,118.32,135.21,118.32,138.66Zm-3.61,0c0-1.69-1.1-2.68-3.28-2.68h-2.9v5.34h2.9C113.61,141.32,114.71,140.34,114.71,138.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M137.42,145.17h-7.14l-1.37,3.3h-3.65l6.86-15.39h3.52l6.88,15.39h-3.73Zm-1.12-2.7-2.44-5.89-2.44,5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M142.94,140.78c0-4.64,3.56-8,8.36-8a7.93,7.93,0,0,1,6.33,2.72l-2.29,2.11a5,5,0,0,0-3.87-1.8,4.93,4.93,0,0,0,0,9.85,4.89,4.89,0,0,0,3.87-1.82l2.29,2.11a7.9,7.9,0,0,1-6.36,2.74C146.5,148.73,142.94,145.41,142.94,140.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M158.73,140.78c0-4.64,3.56-8,8.35-8a8,8,0,0,1,6.34,2.72l-2.29,2.11a5,5,0,0,0-3.87-1.8,4.93,4.93,0,1,0,0,9.85,4.91,4.91,0,0,0,3.87-1.82l2.29,2.11a7.93,7.93,0,0,1-6.36,2.74C162.29,148.73,158.73,145.41,158.73,140.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M174.51,140.78c0-4.58,3.56-8,8.42-8s8.42,3.36,8.42,8-3.58,7.95-8.42,7.95S174.51,145.35,174.51,140.78Zm13.24,0a4.82,4.82,0,1,0-4.82,4.92A4.7,4.7,0,0,0,187.75,140.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M193.9,141.7v-8.62h3.57v8.49c0,2.92,1.27,4.13,3.43,4.13s3.43-1.21,3.43-4.13v-8.49h3.51v8.62c0,4.53-2.59,7-7,7S193.9,146.23,193.9,141.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M225.48,133.08v15.39h-2.93l-7.67-9.34v9.34h-3.52V133.08h2.95l7.65,9.34v-9.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M232.31,136h-4.92v-2.9H240.8V136h-4.92v12.49h-3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M242.71,133.08h3.56v15.39h-3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M264,133.08v15.39h-2.92l-7.68-9.34v9.34h-3.52V133.08h3l7.65,9.34v-9.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M278.09,140.53h3.25v6.25a10.64,10.64,0,0,1-6.22,1.95c-4.84,0-8.4-3.32-8.4-7.95s3.56-8,8.47-8a8.2,8.2,0,0,1,6.44,2.66l-2.29,2.11a5.2,5.2,0,0,0-4-1.74,4.93,4.93,0,1,0,0,9.85,5.68,5.68,0,0,0,2.77-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M111.37,173.34l1.21-2.68a9.09,9.09,0,0,0,5.08,1.6c2.11,0,3-.7,3-1.65,0-2.88-8.95-.9-8.95-6.62,0-2.61,2.11-4.79,6.48-4.79a10.35,10.35,0,0,1,5.35,1.36l-1.1,2.71a8.65,8.65,0,0,0-4.27-1.21c-2.11,0-2.92.79-2.92,1.76,0,2.83,9,.88,9,6.53,0,2.57-2.14,4.77-6.54,4.77A11,11,0,0,1,111.37,173.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M125.64,167.16c0-4.57,3.56-8,8.42-8s8.42,3.36,8.42,8-3.58,8-8.42,8S125.64,171.73,125.64,167.16Zm13.24,0a4.82,4.82,0,1,0-4.82,4.92A4.7,4.7,0,0,0,138.88,167.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M148.72,162.32v4.07h7.13v2.86h-7.13v5.6h-3.56V159.46h11.63v2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M162.51,162.37h-4.93v-2.91H171v2.91h-4.93v12.48h-3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M195.88,159.46l-5,15.39H187l-3.38-10.42-3.5,10.42h-3.8l-5.06-15.39H175l3.48,10.82,3.63-10.82h3.3l3.51,10.91,3.59-10.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M207.49,171.56h-7.14L199,174.85h-3.65l6.86-15.39h3.52l6.88,15.39h-3.73Zm-1.12-2.71L203.93,163l-2.44,5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M224,174.85l-3-4.28h-3.28v4.28H214.2V159.46h6.66c4.11,0,6.68,2.14,6.68,5.59a5,5,0,0,1-3.16,4.86l3.45,4.94Zm-3.34-12.48h-2.9v5.36h2.9c2.18,0,3.28-1,3.28-2.68S222.84,162.37,220.66,162.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M242.27,172v2.85H230.36V159.46H242v2.86H233.9v3.34H241v2.77H233.9V172Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.78,168.81a124.78,124.78,0,0,0,99.56,92.84l.92.17,1.47-.26c50-9,88-45.83,99.65-92.72-28.61-1.91-63.9-3-101-3S99.31,166.92,70.78,168.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M177.34,290.37l-1.47.27-.92-.17a124.78,124.78,0,0,1-99.56-92.84c28.54-1.89,63.67-3,100.62-3s72.37,1.09,101,3C265.3,244.55,227.29,281.35,177.34,290.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M250.83,37.85H209.89a34.31,34.31,0,0,1-32.7,23.94h0A34.29,34.29,0,0,1,144.5,37.85H100.91A87,87,0,0,1,65.27,81.16a293.73,293.73,0,0,1,4.37,30.33h213a290,290,0,0,1,4.34-30A86.9,86.9,0,0,1,250.83,37.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M177.19,0a27.51,27.51,0,1,0,27.5,27.49A27.49,27.49,0,0,0,177.19,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "179.45 17.85 163.87 17.85 163.87 22.44 171.66 22.44 171.66 23.04 171.66 42.2 177.3 42.2 177.3 23.04 177.3 22.44 179.45 22.44 179.45 42.2 185.09 42.2 185.09 22.44 185.09 17.85 179.45 17.85"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 179.45,
    y: 11.5,
    width: 5.64,
    height: 4.59
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge2);
export default __webpack_public_path__ + "static/media/badge2.0c7c3de653e0574e08e54cd08fa39a29.svg";
export { ForwardRef as ReactComponent };